import React from "react";
import { default as RBS_ModalFooter, ModalFooterProps as RBS_ModalFooterProps } from "reactstrap/lib/ModalFooter";
import classNames from "classnames";


export type ModalFooterProps = RBS_ModalFooterProps & {   
   compact?: boolean,
}

const ModalFooter: React.FC<ModalFooterProps> = ({ compact = false, className, ...rest }) => {
   return (<RBS_ModalFooter {...rest} className={classNames({ "modal-footer-compact": compact }, className)} />)
}

export default ModalFooter;